
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductBooksDialog extends Serenity.EntityDialog<ProductBooksRow, any> {
        protected getFormKey() { return ProductBooksForm.formKey; }
        protected getIdProperty() { return ProductBooksRow.idProperty; }
        protected getLocalTextPrefix() { return ProductBooksRow.localTextPrefix; }
        protected getService() { return ProductBooksService.baseUrl; }
        protected getDeletePermission() { return ProductBooksRow.deletePermission; }
        protected getInsertPermission() { return ProductBooksRow.insertPermission; }
        protected getUpdatePermission() { return ProductBooksRow.updatePermission; }

        protected form = new ProductBooksForm(this.idPrefix);

    }
}